import React, { FC } from 'react';
import '../style/VisitorRegister.scss';

interface VisitorRegisterPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const VisitorRegisterPolicyModal: FC<VisitorRegisterPolicyModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div tabIndex={-1} style={{ position: 'relative', zIndex: 1050, display: 'block' }}>
      <div className="visitorRegisterModal">
        {/*  p-modalを追加 */}
        <div className="modal fade show p-modal" role="dialog" tabIndex={-1} style={{ display: 'block' }}>
          <div className="modal-dialog input-important-guide-modal" role="document">
            <div className="modal-content">
              {/* モバイル用閉じるボタン */}
              <button type="button" className="p-modal__close-button" onClick={onClose} aria-label="閉じる" />
              {/* / モバイル用閉じるボタン */}
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  プライバシーポリシー
                </h5>
              </div>
              <div className="modal-body">
                <section className="mid-section-layout consent-guide-confirmation-layout">
                  <div className="container important-guide-confirmation-modal">
                    <div className="sections important-guide-confirmation-modal">
                      <div className="read-and-check-section-top-modal row">
                        <div className="col">
                          <div className="read-section-top">
                            <p className="title">
                              <strong>プライバシーポリシー</strong>
                            </p>
                            <div className="contents">
                              皆様の個人情報（氏名・住所・電話番号等）は、ユーザーの個人認証及びユーザー向け本サービスの提供、本サービスの利用に伴う連絡・メール・DM・各種お知らせ等の配信・送付に利用いたします。
                              <br />
                              本サービスにおいてそれぞれ必要となる項目を記入、または入力いただかない場合は、本サービスを受けられない場合があります。
                              <br />
                              当社は、原則として、ご本人の承諾なく上記目的以外に個人情報を利用または第三者に提供しません。
                              <br />
                              ただし、当社は個人情報取扱い業務の一部または全部を外部委託することがあります。
                              <br />
                              原則として本人に限り、「個人情報の利用目的」の通知、登録した個人情報の開示、訂正、追加または削除、利用停止、ならびに第三者への提供の停止を求めることができるものとします。具体的な方法については下記の個人情報管理の問い合わせ先にご連絡ください。
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr className="separator" />
                      <div className="read-and-check-section-top-modal row">
                        <div className="col">
                          <div className="read-section-top">
                            <p className="title">
                              <strong>個人情報に関するお問い合せ先</strong>
                            </p>
                            <div className="contents">
                              当社個人情報管理責任者、下記電話番号までご連絡ください。
                              <br />
                              電話番号：03-6281-9900
                              <br />
                              電話受付時間：平日10:00から17:00まで
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="modal-footer">
                <button type="button" className="button-common button-common-gray btn btn-secondary" onClick={onClose}>
                  ✕ 閉じる
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" />
      </div>
    </div>
  );
};

export default VisitorRegisterPolicyModal;
